import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL
const ORQUESTRATOR_BASE_URL = import.meta.env.VITE_ORCHESTRATOR_URL

const getRequestConfig = (extraConfig = {}) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  return {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
    ...extraConfig,
  }
}

export const generateArt = async (body, extraConfig = {}) => {
  const config = getRequestConfig(extraConfig)

  return await axios
    .post(`${ORQUESTRATOR_BASE_URL}art/generate`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.code === 'ERR_CANCELED') {
        return { aborted: true, error }
      }

      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      return error
    })
}

export const generateArtWithReference = async (body, extraConfig = {}) => {
  const config = getRequestConfig(extraConfig)

  return await axios
    .post(`${ORQUESTRATOR_BASE_URL}art/generate-with-reference`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.code === 'ERR_CANCELED') {
        return { aborted: true, error }
      }

      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      return error
    })
}

export const editArtWithReference = async (body, extraConfig = {}) => {
  const config = getRequestConfig(extraConfig)

  return await axios
    .post(`${ORQUESTRATOR_BASE_URL}art/edit-with-reference`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.code === 'ERR_CANCELED') {
        return { aborted: true, error }
      }

      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      return error
    })
}


export const editArt = async (artStatusId, body, extraConfig = {}) => {
  const config = getRequestConfig(extraConfig)

  return await axios
    .post(`${ORQUESTRATOR_BASE_URL}art/edit`, { artStatusId, ...body }, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.code === 'ERR_CANCELED') {
        return { aborted: true, error }
      }

      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error post art status', error?.response?.data)
      return error
    })
}

export const checkArtStatus = async (artId) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(`${BASE_URL}art-status/${artId}`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error get IA image status by id', error.response.data)
      return error
    })
}

export const removeBackground = async (image) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .post(`${ORQUESTRATOR_BASE_URL}logo/remove-background`, image, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error get IA image status by id', error.response.data)
      return error
    })
}

export const applyShamanSeal = async (artStatusId, body, extraConfig = {}) => {
  const config = getRequestConfig(extraConfig)

  return await axios
    .post(`${ORQUESTRATOR_BASE_URL}art/apply-shaman-seal`, { artStatusId, ...body }, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.code === 'ERR_CANCELED') {
        return { aborted: true, error }
      }

      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      return error
    })
}

